module.exports = __webpack_public_path__ + "static/media/BroomeAdvertiser-devicecomp-min.86babb53.webp";